<section class="page">
  <div class="container">
    <nav class="crumbs" aria-label="Breadcrumb">
      <ol>
        <li><a routerLink="/">Home</a></li>
        <li aria-current="page">Equipment</li>
      </ol>
    </nav>

    <header class="page__head" appReveal>
      <p class="eyebrow">WHAT WE MANUFACTURE</p>
      <h1>Equipment we design and build</h1>
      <p class="page__lede">Grouped by where each unit sits in the process, so you can read the
        list as a plant rather than as a catalogue.</p>
    </header>

    @for (g of groups; track g.title) {
      <section class="group" appReveal>
        <h2>{{ g.title }}</h2>
        <ul class="eq-grid">
          @for (e of g.items; track e.slug) {
            <li class="eq card-lift">
              <a [routerLink]="['/equipment', e.slug]">
                <h3>{{ e.name }}</h3>
                <p>{{ e.summary }}</p>
                <span class="link-arrow">Details</span>
              </a>
            </li>
          }
        </ul>
      </section>
    }
  </div>
</section>
